"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIndustriesWithOrganisationInfo;

var _react = _interopRequireDefault(require("react"));

var _industriesMap = _interopRequireDefault(require("../constants/industriesMap"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function getIndustrySuffix(count) {
  if (!count) {
    return '-';
  }

  return "".concat(count, " Organisation").concat(count > 1 ? 's' : '');
}
/**
 * Loops through a list of organisations and calculates the industry totals
 * to display next to each industry
 *
 * @param {Array} organisations
 * @param {string} suffixClassName
 *
 * @return {Array}
 */


function getIndustriesWithOrganisationInfo(organisations) {
  var suffixClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var industriesMap = (0, _industriesMap.default)();

  if (organisations && organisations.length) {
    organisations.forEach(function (organisation) {
      industriesMap.set(organisation.industry, industriesMap.get(organisation.industry) + 1);
    });
  }

  return Array.from(industriesMap).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        industry = _ref2[0],
        count = _ref2[1];

    return {
      value: industry,
      suffix: _react.default.createElement("span", {
        className: suffixClassName
      }, getIndustrySuffix(count))
    };
  });
}